import React from 'react';
import { Link } from 'react-router-dom';
import { brandData } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#050505] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-8 md:px-12 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link
              to="/"
              className="font-serif text-3xl tracking-[0.3em] text-white hover:text-white/70 transition-colors duration-500"
            >
              KHAN
            </Link>
            <p className="mt-4 text-white/30 text-sm tracking-wider">
              {brandData.fullName}
            </p>
            <p className="mt-6 text-white/20 text-sm leading-relaxed max-w-xs">
              Creative Director specializing in cinematography, digital marketing, and brand development.
            </p>
          </div>

          {/* Main Navigation */}
          <div className="md:col-span-2">
            <p className="text-white/30 text-xs tracking-[0.25em] uppercase mb-6">Navigate</p>
            <div className="flex flex-col gap-4">
              {[
                { label: 'Home', path: '/' },
                { label: 'Services', path: '/services' },
                { label: 'About', path: '/about' },
                { label: 'Contact', path: '/contact' }
              ].map((item) => (
                <Link
                  key={item.label}
                  to={item.path}
                  className="text-white/50 hover:text-white transition-colors duration-500 text-sm tracking-wide"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Portfolio & Content */}
          <div className="md:col-span-2">
            <p className="text-white/30 text-xs tracking-[0.25em] uppercase mb-6">Portfolio</p>
            <div className="flex flex-col gap-4">
              {[
                { label: 'Success Stories', path: '/stories' },
                { label: 'Podcasts', path: '/podcasts' }
              ].map((item) => (
                <Link
                  key={item.label}
                  to={item.path}
                  className="text-white/50 hover:text-white transition-colors duration-500 text-sm tracking-wide"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Availability */}
          <div className="md:col-span-4">
            <p className="text-white/30 text-xs tracking-[0.25em] uppercase mb-6">Availability</p>
            <p className="text-white/70 text-sm tracking-wide">{brandData.available}</p>
            <p className="text-white/40 text-sm tracking-wide mt-3">Remote & On-site Projects</p>
            
            {/* Contact CTA */}
            <Link
              to="/contact"
              className="inline-block mt-6 px-6 py-3 border border-white/20 text-white/70 text-xs tracking-[0.2em] uppercase hover:bg-white hover:text-black transition-all duration-500"
            >
              Get in Touch
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-20 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/20 text-xs tracking-wider">
            © {currentYear} Hassaan Khan. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-white/20 text-xs tracking-wider">
              Worldwide
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
